import { render, staticRenderFns } from "./StudentEditTabInformation.vue?vue&type=template&id=2342e26c&"
import script from "./StudentEditTabInformation.vue?vue&type=script&lang=js&"
export * from "./StudentEditTabInformation.vue?vue&type=script&lang=js&"
import style0 from "./StudentEditTabInformation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports